import esMessages from '../locales/tr_TR';

const TrLang = {
  messages: {
    ...esMessages,
  },
  locale: 'tr-TR',
};
export default TrLang;
